import React, { useState } from 'react';
import AppTitle from './AppTitle';
import { updateUser } from '../api/otjApi';
import StepCard from './StepCard';
import StepEmail from './StepEmail';
import StepFileUpload from './StepFileUpload';
import StepTypeSelect from './StepTypeSelect';
import StepCredit from './StepCredit';
import StepStart from './StepStart';
import ConfirmModal from './ConfirmModal';

const FilePanel = ({ userEmail = '', onEmailChange, userApiKey, provider, provideruserid }) => {
  // 단계별 상태
  const [email, setEmail] = useState(userEmail);
  const [emailDone, setEmailDone] = useState(!!userEmail);
  const [file, setFile] = useState(null);
  const [fileDone, setFileDone] = useState(false);
  const [type, setType] = useState('');
  const [typeDone, setTypeDone] = useState(false);
  const [credits, setCredits] = useState(1000); // 예시: 보유 크레딧
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // 예상 소모 크레딧: 파일 크기 1byte=1크레딧(예시)
  const estimated = file ? Math.ceil(file.size || 0) : 0;
  const allReady = emailDone && fileDone && typeDone && credits >= estimated && estimated > 0;

  // 이메일 변경/적용 시 updateUser API 연동
  const handleEmailApply = async (newEmail, setEditing) => {
    if (!newEmail) return;
    setLoading(true);
    setError('');
    try {
      await updateUser({ userApiKey, provider, provideruserid, email: newEmail });
      setEmail(newEmail);
      setEmailDone(true);
      if (onEmailChange) onEmailChange(newEmail);
      setEditing(false);
    } catch (e) {
      setError('이메일 변경에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  // StepEmail에 전달할 props 래퍼
  const StepEmailWithApi = (props) => {
    const [editing, setEditing] = useState(!email);
    return (
      <StepEmail
        email={email}
        setEmail={val => setEmail(val)}
        setDone={setEmailDone}
        editing={editing}
        setEditing={setEditing}
        loading={loading}
        error={error}
        onApply={val => handleEmailApply(val, setEditing)}
      />
    );
  };

  const handleStart = () => setShowModal(true);
  const handleSubmit = () => {
    setShowModal(false);
    // TODO: 실제 작업 실행 로직
    alert('작업이 실행되었습니다!');
  };

  return (
    <div className="w-full h-full flex flex-col">
      <AppTitle />
      <div className="flex flex-col items-center justify-center text-gray-700 flex-1">
        <div className="mb-6 text-center text-base text-gray-600 max-w-md">
          파일 단위로 교정과 교열을 수행할 수 있습니다<br />
          작업이 완료되면 메일로 알려드립니다. <br />
          이 페이지를 통해서도 다운로드 받으실 수 있습니다.<br />
          현재 <b>.txt</b>, <b>.pdf</b>, <b>.docx</b> 파일만 지원 합니다.<br />
          아래 단계를 순서대로 진행해 주세요.<br />
        </div>
        <div className="w-full max-w-xl space-y-6">
          <StepCard step={1} title="이메일 확인" done={emailDone}>
            <StepEmailWithApi />
          </StepCard>
          <StepCard step={2} title="파일 첨부" done={fileDone}>
            <StepFileUpload file={file} setFile={setFile} setDone={setFileDone} />
          </StepCard>
          <StepCard step={3} title="작업 유형 선택" done={typeDone}>
            <StepTypeSelect type={type} setType={setType} setDone={setTypeDone} />
          </StepCard>
          <StepCard step={4} title="예상 크레딧" done={allReady}>
            <StepCredit credits={credits} estimated={estimated} />
          </StepCard>
          <StepCard step={5} title="작업 시작" done={false}>
            <StepStart allReady={allReady} onStart={handleStart} />
          </StepCard>
        </div>
      </div>
      <ConfirmModal
        show={showModal}
        email={email}
        file={file}
        type={type}
        estimated={estimated}
        onClose={() => setShowModal(false)}
        onSubmit={handleSubmit}
      />
    </div>
  );
};

export default FilePanel; 